"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
function LiveStudio(_a) {
    var livestream = _a.livestream, video = _a.video;
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-livestreams-ingest-information' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', appendClassname: 'mb-4' }, "Live Studio"),
            react_1.default.createElement(storybook_1.Buttons.Link, { className: 'ml-auto w-full justify-center', icon: 'film', disabled: video.status !== 'published', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/livestreams/" + livestream.id + "/producer", type: 'secondary' }, "Live Studio")));
}
exports.default = LiveStudio;
